import { Button } from "antd";
import React, { useEffect, useState } from "react";
import { ArrowUpOutlined } from '@ant-design/icons';
import { useMediaQuery } from "react-responsive";

export default function ButtonTop(props) {
    const { content = {} } = props;
    const ismobile = useMediaQuery({ query: '(max-width: 716px)' })
    const [visible, setVisible] = useState(false);

    // Component agnostic
    const {
        name = "",
        container = true,
        data = {},
        component = "scroll_to_top",
        date_changed = 0
    } = content;

    // Component specific
    const {
        label = "Scroll to Top",
        align = "right",
        type = 0,
        arrow = false,
        
        allow_mobile_overrides = false,
        mobile_arrow = false,
        mobile_hide = false,
    } = data;

    const scrollToTop = () => {
        window.scroll({top: 0, behavior: "smooth"});
    };

    useEffect(() => {
        const handleScroll = () => {
            setVisible(window.scrollY > 300); 
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);


    const drawRender = () => {

        const _style = {
            textAlign: align,
            zIndex: "10",
            position: "fixed",
            right: align === "right" ? ismobile ?  "25px" : "100px": "0",
            bottom: ismobile ?  "25px" :"50px",
            left: align === "left" ? ismobile ?  "25px" : "100px" : "0",
            display: (allow_mobile_overrides && ismobile && mobile_hide) ? "none" : "initial",
        }

        return (
            (visible && <div>
                <div style={_style}>
                    <Button className={"bm-btn-" + type} onClick={() => scrollToTop()}>
                        {(
                            arrow ||
                            (allow_mobile_overrides && ismobile && mobile_arrow)
                        )
                            ? <ArrowUpOutlined />
                            : label
                        }
                    </Button>
                </div>
            </div>
            )
        );
    }

    return drawRender();
}